// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 138px;
  outline: none;
  float: left;
}

@media only screen and (max-width: 1000px) {
  .logo {
    width: 110px;
    text-align: center;
  }
}
::ng-deep .ant-menu.ant-menu-dark {
  color: #ff5757;
  background: bottom;
}
::ng-deep .ant-badge {
  color: #ff5757;
}

.trigger {
  font-size: 20px;
  line-height: 64px;
  padding: 0 24px 0 0;
  cursor: pointer;
  transition: color 0.3s;
  color: #ff5757;
  float: left;
}
.trigger :hover {
  color: #ff5757;
}

.smallNotificationButtons {
  margin: 0 8px 0 8px;
}

.top-right-hambarg {
  font-size: 20px;
  line-height: 64px;
  cursor: pointer;
  transition: color 0.3s;
  color: #ff5757;
  float: right;
  margin-right: 10px;
}
.top-right-hambarg :hover {
  color: #ff5757;
}

.drawerCloseMenu {
  cursor: pointer;
  transition: color 0.3s;
  color: #ff5757;
}

.header-menu {
  line-height: 64px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.sider-menu {
  height: 100%;
  border-right: 0;
}

.inner-layout {
  padding: 0 24px 24px;
}

nz-breadcrumb {
  margin: 16px 0;
}

nz-content {
  background: #fff;
  padding: 24px;
  min-height: 280px;
}

.notification-icon {
  font-size: 20px !important;
}

::ng-deep .ant-menu-submenu.ant-menu-submenu-popup {
  right: 35px;
}

.header-row {
  box-shadow: 0 5px 8px -2px #d6d6d6;
  z-index: 99;
  padding: 0px 16px;
}

.notification-icon-top-right {
  float: left;
}

::ng-deep.ant-popover-inner-content {
  padding: 10px;
}

.notificationContent {
  max-height: 200px;
  min-height: 200px;
  width: 250px;
  overflow-y: auto;
  padding: 2px;
}
.notificationContent ul {
  list-style: none;
  padding: 0;
}
.notificationContent ul li {
  margin: 0 0 5px;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  box-shadow: 1px 1px 1px 0px #eee;
  cursor: pointer;
}
.notificationContent ul li p {
  margin-bottom: 0;
}
.notificationContent ul li .time {
  display: inline;
  font-size: 12px;
  color: #b7b6b6;
}
.notificationContent ul li:hover {
  box-shadow: 1px 1px 10px 0px rgb(172, 172, 172);
}

.mt-16 {
  margin-top: 16px;
}

.mt-8 {
  margin-top: 8px;
}

.mobile-display {
  display: none;
}

.highlightuser {
  color: #ff5757 !important;
  display: inline-block;
}

.position-reletive {
  position: relative;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 1000px) {
  .trigger {
    padding: 0 12px 0 0;
  }
  .visible-ondesktop {
    display: none;
  }
  .mobile-display {
    display: block;
  }
  .visible-ondesktop.open {
    display: block;
    position: absolute;
    top: calc(100% - 16px);
    min-width: 250px;
    right: calc(50% - 100px);
  }
  .smallNotificationButtons {
    margin: 0 !important;
  }
}
@media only screen and (max-width: 359px) {
  .logo {
    width: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/no-sidebar/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,WAAA;AACF;;AAEA;EACE;IACE,YAAA;IACA,kBAAA;EACF;AACF;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;AAOE;EACE,cAAA;AALJ;;AASA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;AANF;AAQE;EACE,cAAA;AANJ;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAPF;AASE;EACE,cAAA;AAPJ;;AAWA;EACE,eAAA;EACA,sBAAA;EACA,cAAA;AARF;;AAWA;EACE,iBAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;AATF;;AAYA;EACE,YAAA;EACA,eAAA;AATF;;AAYA;EACE,oBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;AATF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,kCAAA;EACA,WAAA;EACA,iBAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AATF;AAUE;EACE,gBAAA;EACA,UAAA;AARJ;AASI;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAPN;AAQM;EACE,gBAAA;AANR;AAWM;EACE,eAAA;EACA,eAAA;EACA,cAAA;AATR;AAYI;EACE,+CAAA;AAVN;;AAcA;EACE,gBAAA;AAXF;;AAaA;EACE,eAAA;AAVF;;AAYA;EACE,aAAA;AATF;;AAWA;EACE,yBAAA;EACA,qBAAA;AARF;;AAUA;EACE,kBAAA;AAPF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AANF;;AAQA;EACE;IACE,mBAAA;EALF;EAOA;IACE,aAAA;EALF;EAOA;IACE,cAAA;EALF;EAOA;IACE,cAAA;IACA,kBAAA;IACA,sBAAA;IACA,gBAAA;IACA,wBAAA;EALF;EAOA;IACE,oBAAA;EALF;AACF;AAQA;EACE;IACE,WAAA;EANF;AACF","sourcesContent":[".logo {\n  width: 138px;\n  outline: none;\n  float: left;\n}\n\n@media only screen and (max-width: 1000px) {\n  .logo {\n    width: 110px;\n    text-align: center;\n  }\n}\n\n::ng-deep {\n  .ant-menu.ant-menu-dark {\n    color: #ff5757;\n    background: bottom;\n  }\n  .ant-col-8 {\n    // flex:none;\n    // max-width: none;\n  }\n  .ant-badge {\n    color: #ff5757;\n  }\n}\n\n.trigger {\n  font-size: 20px;\n  line-height: 64px;\n  padding: 0 24px 0 0;\n  cursor: pointer;\n  transition: color 0.3s;\n  color: #ff5757;\n  float: left;\n\n  :hover {\n    color: #ff5757;\n  }\n}\n\n.smallNotificationButtons {\n  margin: 0 8px 0 8px;\n}\n\n.top-right-hambarg {\n  font-size: 20px;\n  line-height: 64px;\n  cursor: pointer;\n  transition: color 0.3s;\n  color: #ff5757;\n  float: right;\n  margin-right: 10px;\n\n  :hover {\n    color: #ff5757;\n  }\n}\n\n.drawerCloseMenu {\n  cursor: pointer;\n  transition: color 0.3s;\n  color: #ff5757;\n}\n\n.header-menu {\n  line-height: 64px;\n  // top:11px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.sider-menu {\n  height: 100%;\n  border-right: 0;\n}\n\n.inner-layout {\n  padding: 0 24px 24px;\n}\n\nnz-breadcrumb {\n  margin: 16px 0;\n}\n\nnz-content {\n  background: #fff;\n  padding: 24px;\n  min-height: 280px;\n}\n\n.notification-icon {\n  font-size: 20px !important;\n}\n\n::ng-deep .ant-menu-submenu.ant-menu-submenu-popup {\n  right: 35px;\n}\n\n.header-row {\n  box-shadow: 0 5px 8px -2px #d6d6d6;\n  z-index: 99;\n  padding: 0px 16px;\n}\n\n.notification-icon-top-right {\n  float: left;\n}\n\n::ng-deep.ant-popover-inner-content {\n  padding: 10px;\n}\n\n.notificationContent {\n  max-height: 200px;\n  min-height: 200px;\n  width: 250px;\n  overflow-y: auto;\n  padding: 2px;\n  ul {\n    list-style: none;\n    padding: 0;\n    li {\n      margin: 0 0 5px;\n      padding: 10px;\n      border: 1px solid #dbdbdb;\n      border-radius: 5px;\n      box-shadow: 1px 1px 1px 0px #eee;\n      cursor: pointer;\n      p {\n        margin-bottom: 0;\n      }\n      // .content {\n\n      // }\n      .time {\n        display: inline;\n        font-size: 12px;\n        color: #b7b6b6;\n      }\n    }\n    li:hover {\n      box-shadow: 1px 1px 10px 0px rgb(172, 172, 172);\n    }\n  }\n}\n.mt-16 {\n  margin-top: 16px;\n}\n.mt-8 {\n  margin-top: 8px;\n}\n.mobile-display {\n  display: none;\n}\n.highlightuser {\n  color: #ff5757 !important;\n  display: inline-block;\n}\n.position-reletive {\n  position: relative;\n}\n.search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n@media only screen and (max-width: 1000px) {\n  .trigger {\n    padding: 0 12px 0 0;\n  }\n  .visible-ondesktop {\n    display: none;\n  }\n  .mobile-display {\n    display: block;\n  }\n  .visible-ondesktop.open {\n    display: block;\n    position: absolute;\n    top: calc(100% - 16px);\n    min-width: 250px;\n    right: calc(50% - 100px);\n  }\n  .smallNotificationButtons {\n    margin: 0 !important;\n  }\n}\n\n@media only screen and (max-width: 359px) {\n  .logo {\n    width: 90px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
